import { useEffect } from "react";

const B = {
  blue:"#1b57ce", blueD:"#1245a8", blueL:"#e8f0fd",
  orange:"#ea592d", white:"#ffffff", gray:"#f4f5f7",
  grayB:"#e8eaed", muted:"#6b7280", text:"#111827",
};

const EMPRESA  = "Carga Express, Sociedad Anónima de Capital Variable";
const NIT      = "0614-051222-106-6";
const DIRECCION= "C. Urb. Santa Tecla, Calle 4ta Oriente, Oficina 1-6, Santa Tecla, La Libertad, El Salvador";
const CORREO   = "flashboxsv@gmail.com";
const FECHA    = "1 de julio de 2025";

const secciones = [
  {
    titulo: "1. Responsable del Tratamiento",
    contenido: `${EMPRESA}, con NIT ${NIT}, con domicilio en ${DIRECCION}, es la entidad responsable del tratamiento de los datos personales recopilados a través de la plataforma Flashbox (en adelante "Flashbox" o "nosotros").`,
  },
  {
    titulo: "2. Datos que Recopilamos",
    contenido: `Al registrarse y utilizar nuestros servicios, recopilamos los siguientes datos personales:\n\n• Datos de identidad: nombre completo, Documento Único de Identidad (DUI) y fotografía del mismo.\n• Datos de contacto: correo electrónico, número de teléfono y dirección de entrega.\n• Datos de uso: historial de paquetes, prealertas, transacciones y navegación dentro de la plataforma.\n• Datos técnicos: dirección IP, tipo de navegador y dispositivo, únicamente con fines de seguridad y funcionamiento del servicio.`,
  },
  {
    titulo: "3. Finalidad del Tratamiento",
    contenido: `Los datos personales recopilados se utilizan exclusivamente para:\n\n• Prestación del servicio courier (recepción, tramitación aduanal y entrega de paquetes).\n• Verificación de identidad y cumplimiento de obligaciones legales.\n• Comunicación sobre el estado de sus envíos y novedades del servicio.\n• Prevención de fraudes y cumplimiento de la legislación salvadoreña aplicable.\n• Mejora continua de la plataforma y la experiencia del usuario.`,
  },
  {
    titulo: "4. Base Legal del Tratamiento",
    contenido: `El tratamiento de sus datos personales se fundamenta en:\n\n• La ejecución del contrato de servicio que usted acepta al registrarse.\n• El cumplimiento de obligaciones legales aplicables en El Salvador.\n• El consentimiento expreso que usted otorga al momento del registro, especialmente para el tratamiento del DUI.`,
  },
  {
    titulo: "5. Protección del DUI",
    contenido: `El número y la fotografía de su Documento Único de Identidad (DUI) son datos sensibles que Flashbox trata con especial cuidado. Se utilizan únicamente para verificar su identidad y cumplir con las obligaciones legales de identificación de clientes. No serán compartidos con terceros salvo requerimiento expreso de autoridad competente. El acceso a esta información está restringido exclusivamente al personal autorizado de Flashbox.`,
  },
  {
    titulo: "6. Conservación de los Datos",
    contenido: `Sus datos personales serán conservados mientras mantenga una cuenta activa en Flashbox y durante el tiempo necesario para cumplir con las obligaciones legales y contables aplicables. Una vez solicitada la baja del servicio, sus datos serán eliminados en un plazo máximo de 30 días hábiles, salvo que la ley exija su conservación por un período determinado.`,
  },
  {
    titulo: "7. Compartición de Datos con Terceros",
    contenido: `Flashbox no vende, alquila ni cede sus datos personales a terceros con fines comerciales. Sus datos podrán ser compartidos únicamente con:\n\n• Proveedores de servicios logísticos y de transporte necesarios para la ejecución del envío.\n• Autoridades aduanales y gubernamentales cuando así lo requiera la legislación.\n• Proveedores tecnológicos (alojamiento, bases de datos) que actúan bajo estrictos acuerdos de confidencialidad.`,
  },
  {
    titulo: "8. Seguridad de los Datos",
    contenido: `Flashbox implementa medidas técnicas y organizativas adecuadas para proteger sus datos personales contra acceso no autorizado, pérdida, alteración o divulgación. Entre estas medidas se incluyen: almacenamiento cifrado, acceso restringido por roles, y políticas de seguridad interna. Sin embargo, ningún sistema de seguridad es infalible y no podemos garantizar la seguridad absoluta de la información transmitida por internet.`,
  },
  {
    titulo: "9. Derechos del Titular",
    contenido: `Usted tiene derecho a:\n\n• Acceder a sus datos personales almacenados en Flashbox.\n• Rectificar datos incorrectos o desactualizados.\n• Solicitar la eliminación de sus datos cuando ya no sean necesarios para la finalidad para la que fueron recopilados.\n• Oponerse al tratamiento de sus datos en determinadas circunstancias.\n\nPara ejercer estos derechos, puede contactarnos a través del correo ${CORREO} o WhatsApp +503 7842-7302.`,
  },
  {
    titulo: "10. Cookies y Tecnologías de Seguimiento",
    contenido: `Flashbox utiliza cookies técnicas necesarias para el funcionamiento de la plataforma. Para más información sobre el uso de cookies y cómo gestionarlas, consulte nuestra Política de Cookies disponible en el pie de página del sitio web.`,
  },
  {
    titulo: "11. Modificaciones a esta Política",
    contenido: `Flashbox se reserva el derecho de actualizar esta Política de Privacidad en cualquier momento para adaptarla a cambios legales o mejoras en el servicio. Los cambios serán publicados en esta página con indicación de la fecha de actualización. El uso continuado del servicio implica la aceptación de la política vigente.`,
  },
  {
    titulo: "12. Legislación Aplicable",
    contenido: `Esta Política de Privacidad se rige por las leyes de la República de El Salvador. En caso de controversia, las partes se someten a la jurisdicción de los tribunales competentes de El Salvador.`,
  },
  {
    titulo: "13. Contacto para Asuntos de Privacidad",
    contenido: `Para cualquier consulta relacionada con el tratamiento de sus datos personales:\n\nCorreo electrónico: ${CORREO}\nWhatsApp: +503 7842-7302\nDirección: ${DIRECCION}`,
  },
];

export default function Privacidad() {
  useEffect(() => {
    document.title = "Política de Privacidad — Flashbox";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontFamily: "'Segoe UI', system-ui, sans-serif", background: B.white, minHeight: "100vh", color: B.text }}>

      {/* Header */}
      <div style={{ background: B.blue, padding: "28px 24px" }}>
        <div style={{ maxWidth: 860, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <a href="/" style={{ textDecoration: "none" }}>
            <span style={{ fontSize: 22, fontWeight: 900, color: B.white, letterSpacing: "-0.5px" }}>
              Flash<span style={{ color: "#f6e24d" }}>box</span>
            </span>
          </a>
          <a href="/" style={{ fontSize: 13, color: "rgba(255,255,255,0.75)", textDecoration: "none", fontWeight: 600 }}>
            ← Volver al inicio
          </a>
        </div>
      </div>

      {/* Contenido */}
      <div style={{ maxWidth: 860, margin: "0 auto", padding: "48px 24px 80px" }}>

        <div style={{ marginBottom: 40 }}>
          <h1 style={{ fontSize: 32, fontWeight: 900, color: B.text, marginBottom: 8, letterSpacing: "-0.5px" }}>
            Política de Privacidad
          </h1>
          <p style={{ fontSize: 14, color: B.muted }}>
            Última actualización: {FECHA} · {EMPRESA}
          </p>
        </div>

        {/* Intro */}
        <div style={{ background: B.blueL, borderRadius: 12, padding: "20px 24px", marginBottom: 40, borderLeft: `4px solid ${B.blue}` }}>
          <p style={{ fontSize: 15, color: B.text, lineHeight: 1.7, margin: 0 }}>
            En <strong>Flashbox</strong> nos comprometemos a proteger su privacidad y a tratar sus datos personales con total transparencia y responsabilidad. Esta política explica qué datos recopilamos, cómo los usamos y cuáles son sus derechos.
          </p>
        </div>

        {/* Secciones */}
        <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
          {secciones.map((s) => (
            <div key={s.titulo}>
              <h2 style={{ fontSize: 17, fontWeight: 800, color: B.text, marginBottom: 10 }}>{s.titulo}</h2>
              <p style={{ fontSize: 15, color: "#374151", lineHeight: 1.8, margin: 0, whiteSpace: "pre-line" }}>
                {s.contenido}
              </p>
            </div>
          ))}
        </div>

        {/* Footer legal */}
        <div style={{ marginTop: 56, paddingTop: 32, borderTop: `1px solid ${B.grayB}`, display: "flex", flexWrap: "wrap", gap: 16, justifyContent: "space-between", alignItems: "center" }}>
          <p style={{ fontSize: 13, color: B.muted, margin: 0 }}>
            © 2025 {EMPRESA} · NIT {NIT}
          </p>
          <div style={{ display: "flex", gap: 20 }}>
            <a href="/terminos" style={{ fontSize: 13, color: B.blue, textDecoration: "none", fontWeight: 600 }}>Términos y Condiciones</a>
            <a href="/" style={{ fontSize: 13, color: B.blue, textDecoration: "none", fontWeight: 600 }}>Inicio</a>
          </div>
        </div>
      </div>
    </div>
  );
}
